// extracted by mini-css-extract-plugin
export default {"submitForm":"Submission_submitForm__ZWSNi","submitButton":"Submission_submitButton__198ZU"};